import { Component, computed, input, output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

/**
 * Shared header. Each portal projects its own center control with the headerCenter attribute.
 */
@Component({
    selector: 'lib-header',
    standalone: true,
    imports: [CommonModule, MatButtonModule, MatIconModule],
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent {
  title = input<string>('Portal');
  userName = input<string | null>(null);
  userEmail = input<string | null>(null);
  logoUrl = input<string | null>(null);
  /** Square LR mark for narrow viewports. Defaults to a cropped sibling of `logoUrl`. */
  logoMarkUrl = input<string | null>(null);
  showMenuButton = input<boolean>(true);
  /** Client portal has no header-end actions, so the selector can sit on the right on small screens. */
  endOnMobile = input(false);
  /** Attorney bar matches the prototype: 72px. Other portals keep the taller header. */
  compact = input(false);
  /** Display names for all roles on the active portal (empty when unknown). */
  userRoles = input<string[]>([]);

  protected readonly mobileLogoSrc = computed(() => {
    const markUrl = this.logoMarkUrl();
    if (markUrl) {
      return markUrl;
    }
    const logoUrl = this.logoUrl();
    if (logoUrl?.includes('legal-resources-logo.png')) {
      return logoUrl.replace('legal-resources-logo.png', 'legal-resources-logo-mark.png');
    }
    return logoUrl;
  });

  menuToggle = output<void>();
  loginClick = output<void>();
  logoutClick = output<void>();
  profileClick = output<void>();
  settingsClick = output<void>();
}
